import React from "react";
import UserProjects from "../Static Files/UserProjects.json";

async function GetUserProjectData(projectObj, isLoggedIn, editIndex, changeLang) {
 
  if (changeLang !== undefined) {
    return await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(projectObj);
      }, 500);
    });
  } else if (editIndex !== undefined) {
    return await new Promise((resolve, reject) => {
   
      resolve(GetUserProjectData(projectObj, isLoggedIn, undefined, changeLang));
    });
  } else {
    return await new Promise((resolve, reject) => {
      let userProjects = JSON.parse(JSON.stringify(UserProjects))[
        projectObj["PreorderText"]["SewingModelId"]
      ]["data"];

      let temp = {};

      let imageExtensionList = ["jpg", "png", "jpeg", "jiff", "gif", "webp"];
      let pdfExtensionList = ["pdf"];

      let promise3 = new Promise((resolve, reject) => {
        if (
          projectObj["SewingOrderAttachments"] &&
          projectObj["SewingOrderAttachments"].length > 0
        ) {
          temp["uploadedImagesFile"] = [];
          temp["uploadedImagesURL"] = [];
          temp["uploadedPDFFile"] = [];
          temp["uploadedPDFURL"] = [];
          projectObj["SewingOrderAttachments"].forEach((obj, index) => {
            let extensionSearch = /(?:\.([^.]+))?$/;
            let extension = extensionSearch.exec(obj["UserFileName"])[1].toLowerCase();
            // console.log(extension,imageExtensionList.indexOf(extension) > -1,pdfExtensionList.indexOf(extension) > -1);
            if (imageExtensionList.indexOf(extension) > -1) {
              temp["uploadedImagesURL"][index] = obj["FileUrl"];
              temp["uploadedImagesFile"][index] = obj["UserFileName"];
            } else if (pdfExtensionList.indexOf(extension) > -1) {
              temp["uploadedPDFURL"][index] = obj["FileUrl"];
              temp["uploadedPDFFile"][index] = obj["UserFileName"];
            }
            if (index === projectObj["SewingOrderAttachments"].length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });

      promise3.then(() => {
        Object.keys(projectObj["PreorderText"]).forEach((key, index) => {
          if (projectObj["PreorderText"][key] !== null || projectObj["PreorderText"][key] !== "") {
            let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
            if (tempObj) {
              if (tempObj["titleValue"] === null) {
                temp[tempObj["cart"]] = projectObj["PreorderText"][key];
              } else {
                temp[tempObj["cart"]] =
                  tempObj["titleValue"][projectObj["PreorderText"][key]?.toString()];
              }
            } else {
              // console.log(key);
            }
          }
          if (index === Object.keys(projectObj["PreorderText"]).length - 1) {
            temp["Accessories"] =
              (projectObj["PreorderText"]["SewingOrderDetails"]
                ? projectObj["PreorderText"]["SewingOrderDetails"][0]
                  ? projectObj["PreorderText"]["SewingOrderDetails"][0]["Accessories"]
                  : []
                : []) || [];
            // console.log(temp["Accessories"]);

            let promiseArr = [];
            Object.keys(temp).forEach((key, j) => {
              promiseArr[j] = new Promise((resolve, reject) => {
                if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
                  let tempObj = userProjects.find((obj) => obj["cart"] === key);
                  if (tempObj) {
                    if (tempObj["apiAcc"] !== undefined) {
                      if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                        const i = temp["Accessories"]
                          .filter((n) => n)
                          .findIndex(
                            (e) =>
                              e &&
                              e.SewingAccessoryValue &&
                              e.SewingAccessoryValue === tempObj["apiAccValue"][temp[key]] &&
                              tempObj["apiAccValue"][temp[key]]["SewingAccessoryValue"]
                          );
                        if (i > -1) {
                          temp["Accessories"].splice(i, 1);
                        }
                      } else {
                      }
                    }
                  }
                }
                resolve();
              });
            });
            Promise.all(promiseArr).then(() => {
              // WindowDescription is not in UserProjects mapping; keep custom window label from cart
              const windowDescription =
                projectObj["PreorderText"]["WindowDescription"] !== undefined
                  ? projectObj["PreorderText"]["WindowDescription"]
                  : projectObj["WindowDescription"];
              if (windowDescription !== undefined) {
                temp["WindowDescription"] = windowDescription;
              }

              if (projectObj["PreorderText"]["SewingModelId"] === "0099") {
                const topAcc = projectObj["PreorderText"]["Accessories"];
                if (Array.isArray(topAcc) && topAcc.length) {
                  temp["Accessories"] = topAcc;
                }
              } else if (projectObj["PreorderText"]["SewingModelId"] === "0321") {
                const topAcc = projectObj["PreorderText"]["Accessories"];
                if (Array.isArray(topAcc) && topAcc.length) {
                  temp["Accessories"] = topAcc;
                }
                if (projectObj["PreorderText"].step6CHead)
                  temp.step6CHead = projectObj["PreorderText"].step6CHead;
                if (projectObj["PreorderText"].step6BHead)
                  temp.step6BHead = projectObj["PreorderText"].step6BHead;
                if (projectObj["PreorderText"].step6DHead)
                  temp.step6DHead = projectObj["PreorderText"].step6DHead;
              }
              if (projectObj["PreorderText"]["RailDesignEnA"] === "Cord Draw Track") {
                temp["ControlPositionA"] = projectObj["PreorderText"]["ControlPositionA"];
              }
             
              resolve(temp);
            });
          }
        });
      });
    });
  }
}

export default GetUserProjectData;
